import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavIcon = (props) => {
    const { path, label, icon, activePaths } = props.data;
    const currentPath = props.currentPath;
    const disableDuplicateStage = props.disableDuplicateStage;

    const isPath = currentPath === path;
    let hasActivePath = false;
    activePaths.forEach((p) => {
        if (currentPath.includes(p)) {
            hasActivePath = true;
        }
    });

    const activeClass = isPath || hasActivePath ? "-active" : "";

    if (label === "Duplicate Staging" && disableDuplicateStage) {
        return;
    }

    return (
        <div className="link-container">
            <Link
                to={path}
                className={activeClass}
                onClick={props.onClick}
                title={label}
            >
                <FontAwesomeIcon icon={icon} />
                <p>{label}</p>
            </Link>
        </div>
    );
};

export default NavIcon;
